import { useNavigate } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HeroSection() {
  const navigate = useNavigate();
  const mainFeature = featuredComics[0];

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src={mainFeature.coverLarge}
        alt={mainFeature.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex items-end pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="flex flex-col lg:flex-row items-start lg:items-end gap-8">
            <div className="w-32 md:w-40 shrink-0">
              <img
                src={mainFeature.cover}
                alt={mainFeature.title}
                className="w-full rounded-lg shadow-2xl"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-3">
                <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  {mainFeature.status}
                </span>
                <span className="text-background-50/80 text-sm">{mainFeature.categoryName}</span>
                <span className="text-background-50/60 text-sm">
                  <i className="ri-star-fill text-primary-400 mr-1"></i>
                  {mainFeature.rating}
                </span>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
                {mainFeature.title}
              </h1>
              <p className="text-background-50/80 text-sm md:text-base max-w-2xl line-clamp-2 mb-5">
                {mainFeature.description}
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <button
                  onClick={() => navigate(`/comic/${mainFeature.slug}`)}
                  className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始阅读
                </button>
                <button
                  onClick={() => navigate(`/comic/${mainFeature.slug}`)}
                  className="px-5 py-2.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-sm font-medium hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看详情
                </button>
                <span className="text-background-50/60 text-xs ml-2">
                  <i className="ri-eye-line mr-1"></i>
                  {(mainFeature.views / 10000).toFixed(0)}万次阅读
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex items-center gap-1.5">
        {featuredComics.map((_, idx) => (
          <div
            key={idx}
            className={`w-2 h-2 rounded-full transition-all ${idx === 0 ? 'bg-primary-500 w-6' : 'bg-background-50/40'}`}
          />
        ))}
      </div>
    </section>
  );
}